import { createSignal } from 'https://cdn.jsdelivr.net/npm/solid-js@1.7.3/+esm';

const SideCart = (() => {
  const [isOpen, setIsOpen] = createSignal(false);

  const toggleCart = () => setIsOpen((open) => !open);
  const openCart = () => setIsOpen(true);
  const closeCart = () => setIsOpen(false);

  return {
    isOpen: isOpen,
    toggleCart,
    openCart,
    closeCart,
  };
})();

export default SideCart;
